const app_base_url = "/carnes";
const aplicacao = "CONVENIOS_TRANSFERENCIAS_ACORDOS";
const aplicacao_full_url = "https://solucoes.sinsoft.com.br/carnes/";
//"https://localhost:3000"
//
const sinsoft_url = "http://sinsoft.com.br";
const api_url = "https://sistema.sinsoft.com.br/ManipulacaoArquivosApi/"
//const api_url = "http://localhost:3137/"

const login_api = "https://solucoes.sinsoft.com.br/api/login-unico";
const unico_api = "https://solucoes.sinsoft.com.br/api/consultas-unico";
const enderecos_api = "https://solucoes.sinsoft.com.br/api/enderecos";

const chave = "0576c1cb-7993-45c6-bc41-2236ae048cd1";

export { app_base_url, sinsoft_url, login_api, aplicacao, api_url, unico_api, enderecos_api, aplicacao_full_url, chave }